// const CLIENT_URL = "https://salmon-moss-082248e10.4.azurestaticapps.net/";
//const CLIENT_URL = "https://orange-meadow-0e70c260f.2.azurestaticapps.net/";
const CLIENT_URL = "https://empqrcode.balmerlawrie.ae/";


// const API_URL = "https://blpeopledir.remodigital.in/";
const API_URL = "https://blpeopledir.balmerlawrie.ae/";
//const API_URL = "https://blcardsuat.remodigital.in/";
// const API_URL = "http://localhost:5000/";

// const CLIENT_URL = "http://localhost:3000/";

export { API_URL, CLIENT_URL };
